/*
 * Copyright (c) 2024, Behçet Atalay
 * All rights reserved.
 *
 * @project   kaan-web
 * @author    Behçet Atalay
 * @site      https://www.technobecet.com
 * @date      17 February 2024
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './Layout/styles.css';
import reportWebVitals from './reportWebVitals';
import { router } from './App/Routes/routes';
import { RouterProvider } from 'react-router-dom';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
